export const SET_SELECTED_SCHOOL_ID = 'SET_SELECTED_SCHOOL_ID';